import {
    createTutorialVideo,
    deleteTutorialVideo,
    editTutorialVideo,
    getTutorialVideos,
} from './tutorialVideos.action';
export { tutorialVideosReducer } from './tutorialVideos.reducer';
export { watchTutorialVideos } from './tutorialVideos.saga';

export const tutorialVideosActions = {
    getTutorialVideos,
    createTutorialVideo,
    editTutorialVideo,
    deleteTutorialVideo,
};
